export class UserSessions {
    sessionId: string;
    userId: string;
    deviceId: string;
    loginTime: Date;
    isActive: boolean;
    editedBy: string;
    editedDate: Date;
}
